import { RightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { openSubmenu, toggleSubMenu } from '../../../../modules/ui/store/ui-slice';
import useMenuItems, { MenuItem } from '../../hooks/use-menu-items';
import MainMenuCollapseHeader from '../main-menu-collapse-header/main-menu-collapse-header';
import styles from './main-menu-tablet.module.css';

const MainMenuTablet = (): JSX.Element => {
  const dispatch = useDispatch();
  const [menuItems, activeMenuItem] = useMenuItems();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleTabletSubMenu = (item: MenuItem) => {
    if (item.path === location.pathname) {
      dispatch(toggleSubMenu());
    } else {
      dispatch(openSubmenu());
      navigate(item.path);
    }
  };

  return (
    <div className={styles.tabletCollapsableContainer}>
      {menuItems.map(item => (
        <MainMenuCollapseHeader
          key={item.key}
          menuItem={item}
          activeMenuItem={activeMenuItem}
          toggleTabletSubMenu={() => toggleTabletSubMenu(item)}
          tabletIcon={
            item.subMenuContent && (
              <Row justify="center" align="middle">
                <Col>
                  <RightOutlined className={styles.icon} />
                </Col>
              </Row>
            )
          }
        />
      ))}
    </div>
  );
};

export default MainMenuTablet;
